import React, { Component } from 'react'
import { Section, Checkbox } from '../../../../components'
import { STRING } from '../../../../helpers'

export default class DisplayDummy extends Component {
  render() {
    const { formData, editRoleDetail, isSetState } = this.props
    return (
      <Section className="form-group">
        <label className="display-dummy">
          Display Dummy <br />
          Supplier Name
        </label>
        <Section className="form-group-control">
          <Section className="form-group-inner-wrapper">
            <Checkbox
              id="no_display_dummy"
              value="no_display_dummy"
              type="radio"
              name="no_display_dummy"
              checked={!formData.step2.eventInformation.is_display_dummy}
              className="inline"
              onChange={e => {
                formData.step2.eventInformation.is_display_dummy = false
                isSetState({
                  formData,
                  isErrDisplayDummy: false,
                })
              }}
              disabled={!editRoleDetail ? true : false}
            >
              <div className="display-dummy" style={{ width: '105px' }}>
                No
              </div>
            </Checkbox>
            <Checkbox
              id="yes_display_dummy"
              value="yes_display_dummy"
              type="radio"
              name="yes_display_dummy"
              checked={formData.step2.eventInformation.is_display_dummy}
              className="inline"
              onChange={e => {
                formData.step2.eventInformation.is_display_dummy = true
                isSetState({
                  formData,
                })
              }}
              disabled={!editRoleDetail ? true : false}
            >
              <div className="display-dummy">Yes</div>
            </Checkbox>
          </Section>
          <Section className="message">{STRING.INVALID}</Section>
        </Section>
      </Section>
    )
  }
}
